"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var indexGroupUrl_1 = __importDefault(require("./DirectoryTableRow/indexGroupUrl"));
var DirectoryTablePagination_1 = __importDefault(require("./DirectoryTablePagination"));
var AppMargins_1 = require("../../../../app/components/AppMargins");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        resultsTable: (_a = {
                boxSizing: 'content-box',
                maxWidth: theme.spacing(180)
            },
            _a[theme.breakpoints.up('md')] = {
            // marginTop: theme.spacing(3),
            },
            _a),
    });
});
/**
 * @component Holds the entire search results in table format and the pagination bar.
 */
var DirectoryTableGroupURL = react_1.default.memo(function (_a) {
    var searchResults = _a.searchResults, pageCount = _a.pageCount, rowsPerPage = _a.rowsPerPage, resultsCount = _a.resultsCount, currentPage = _a.currentPage, disablePagination = _a.disablePagination, changePageHandler = _a.changePageHandler, changeRowsPerPageHandler = _a.changeRowsPerPageHandler, setUrlInfo = _a.setUrlInfo, setOpen = _a.setOpen, rankOffset = _a.rankOffset;
    var classes = useStyles();
    return (react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
        react_1.default.createElement(core_1.Table, { "aria-label": "search results table", className: classes.resultsTable },
            react_1.default.createElement(core_1.TableBody, null,
                searchResults.map(function (url, index) { return (react_1.default.createElement(indexGroupUrl_1.default, { url: url, setUrlInfo: setUrlInfo, setOpen: setOpen, index: index + 1 + rankOffset })); }),
                react_1.default.createElement(DirectoryTablePagination_1.default, { pageCount: pageCount, rowsPerPage: rowsPerPage, currentPage: currentPage, changePageHandler: changePageHandler, changeRowsPerPageHandler: changeRowsPerPageHandler, resultsCount: resultsCount, disablePagination: disablePagination })))));
});
exports.default = DirectoryTableGroupURL;
